import type { GoogleMapInstance, GoogleMapsApi, LatLngLiteral, MapPolyline } from '@/shared/google/googleMaps'
import type { LatLng, Radii } from '@/features/detection/domain/geometry'

// Calque de calibration TEMPORAIRE : drapeau (croix magenta, point réellement utilisé par le moteur), cercles de
// capture / travail / sortie autour du drapeau, et trait pastille → drapeau. À retirer après le lot O7.

export interface DebugFlag {
  id: string
  flag: LatLngLiteral
  marker: LatLngLiteral | null
}

export interface DebugFlagLayer {
  update: (flags: readonly DebugFlag[], radii: Radii) => void
  destroy: () => void
}

const crossHalfM = 2.5

/** Cercle approché (polygone fermé) autour d'un point, pour tracer les rayons du profil sur la carte. */
export function circlePath(center: LatLng, radiusM: number, segments = 48): LatLng[] {
  const latPerM = 1 / 111_320
  const lngPerM = latPerM / Math.cos((center.lat * Math.PI) / 180)
  return Array.from({ length: segments + 1 }, (_, index) => {
    const angle = (2 * Math.PI * index) / segments
    return { lat: center.lat + Math.sin(angle) * radiusM * latPerM, lng: center.lng + Math.cos(angle) * radiusM * lngPerM }
  })
}

export function createDebugFlagLayer(api: GoogleMapsApi, map: GoogleMapInstance): DebugFlagLayer {
  let lines: MapPolyline[] = []
  const clear = () => {
    for (const line of lines) line.setMap(null)
    lines = []
  }
  const draw = (path: LatLngLiteral[], color: string, weight: number, opacity = 0.95) => {
    lines.push(
      new api.Polyline({ map, path, strokeColor: color, strokeOpacity: opacity, strokeWeight: weight, clickable: false }),
    )
  }
  return {
    update(flags, radii) {
      clear()
      for (const { flag, marker } of flags) {
        draw(circlePath(flag, radii.exitDistanceM), '#EF4444', 2, 0.8)
        draw(circlePath(flag, radii.workRadiusM), '#F59E0B', 2, 0.9)
        draw(circlePath(flag, radii.captureRadiusM), '#22C55E', 3)
        const latM = crossHalfM / 111_320
        const lngM = latM / Math.cos((flag.lat * Math.PI) / 180)
        draw([{ lat: flag.lat - latM, lng: flag.lng - lngM }, { lat: flag.lat + latM, lng: flag.lng + lngM }], '#FF00FF', 4)
        draw([{ lat: flag.lat - latM, lng: flag.lng + lngM }, { lat: flag.lat + latM, lng: flag.lng - lngM }], '#FF00FF', 4)
        if (marker) draw([marker, flag], '#FFFFFF', 1, 0.7)
      }
    },
    destroy: clear,
  }
}
